import { Input, Table } from "antd";
import useComercialTable from "./hooks/useComercialTable";
const { Search } = Input;




const ComercialPage = () => {
    const { columns, dataSource, handleChange, clearFilters, areFilters, updateData, loading } = useComercialTable();

    return (
        <div className="flex grow h-full px-4 py-6    box-border">
            <div className="w-full h-full   text-center max-w-[2048px] mx-auto flex flex-col gap-5   ">
                <div className="flex flex-col gap-2">
                    <Search
                        loading={loading}
                        className="w-full mx-auto "
                        placeholder="Busca por nombre o descripción"
                        allowClear
                        enterButton="Buscar"
                        size="large"
                        onSearch={updateData}
                    />
                    <div className="w-full flex justify-end">
                        <button onClick={clearFilters} className="bg-[#1876FF] py-1 px-2 rounded-md text-white  hover:cursor-pointer disabled:bg-gray-400" disabled={!areFilters}>Limpiar filtros</button>
                    </div>
                </div>

                <div className="flex-1 overflow-hidden bg-gray-100">
                    <Table
                        className="h-full"
                        scroll={{ y: window.innerHeight - 64 - 200, x: 700 }}
                        pagination={false}
                        dataSource={dataSource}
                        onChange={handleChange}
                        columns={columns} />

                </div>
            </div>



        </div>
    );
}

export default ComercialPage;